import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
import { auth } from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private userCollectionName = 'users';
  public userdata$: any;
  public userList: any;
  public campus: any;
  ////
  private userSubject = new BehaviorSubject<any>({});
  currentUser$: Observable<any> = this.userSubject.asObservable()

  documentToDomainObject = (_) => {
    const object = _.payload.doc.data();
    object.id = _.payload.doc.id;
    return object;
  };
  constructor(
    public afAuth: AngularFireAuth,
    public router: Router,
    private db: AngularFirestore
  ) {
    this.loadUser()
  }

  loadUser() {
    this.afAuth.authState.subscribe((user) => {
      if (user) {
        this.getUsers().subscribe((res: any) => {
          res.forEach((element: any) => {
            if (element.user === user.email) {
              this.userdata$ = user;
              localStorage.setItem('user_1', JSON.stringify(this.userdata$));
              this.user.displayName = user.displayName;
              this.user.uid = user.uid;
              this.user.email = user.email;
              this.user.photoURL = user.photoURL;
              this.user.login = true;
              this.user.campus = element.campus;
              this.campus = element.campus;
              this.setUser(this.user);
              this.router.navigate(['mision-control']);
            }
          });

        });
      } else {
        localStorage.setItem('user_1', 'null');
      }
    });

  }

  public user: any = {};




  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user_1')!);
    // if (user !== null && user.emailVerified !== false) {
    //   this.loadUser()
    //   return true

    // } else {
    //   return false
    // }
    return (user !== null && user.emailVerified !== false) ? true : false;

  }


  getCurrentUser() {
    return this.user;
  }
  googleAuth() {
    try {
      this.afAuth.signInWithPopup(new auth.GoogleAuthProvider());
    } catch (error) {
      // console.log(error);
    }
  }
  googleLogout() {
    this.user = {};
    this.afAuth.signOut();
    this.router.navigate(['login']);

  }
  getUsers() {
    this.userList = this.db
      .collection(this.userCollectionName, (ref) => ref.orderBy('user', 'desc'))
      .snapshotChanges()
      .pipe(map((actions) => actions.map(this.documentToDomainObject)));
    return this.userList;
  }

  setUser(user: any) {
    this.userSubject.next(user)
  }
}
